<template>
  <or-layout>
    <div>{{month.format('LL')}}</div>
    <a-calendar v-model="month">
      <template slot="dateCellRender">
        <div class="cell">
          <ul class="events">
            <li>
              <a-tag color="red">08:30-10.25 数与代数</a-tag>
            </li>
            <li>
              <a-tag color="green">10:35 12.30 数与代数</a-tag>
            </li>
          </ul>

          <a-button class="add" type="primary" size="small">添加计划</a-button>
        </div>
      </template>
    </a-calendar>
  </or-layout>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      month: moment()
    };
  }
};
</script>


<style lang="less" scoped>
.cell {
  height: 100%;
  text-align: center;

  .add {
    opacity: 0;
    transition: all 1s;
  }

  &:hover {
    .add {
      opacity: 1;
      display: inline;
    }
  }
}

.events {
  margin: 0;
  padding: 0;

  li {
    font-size: 12px;
    margin-bottom: 5px;
  }
}
</style>